import * as classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { INFRASTRUCTURE_MAP_ICON_MAP } from '../../constants/infrastructureIcons';
import { INFRASTRUCTURE_MAIN } from '../../containers/MapContainer';
import { EType } from '../../types/map';

export interface IMapPinProps {
  id: string;
  type: 'main' | EType;
  active?: boolean;
  price?: string;
}

export const MapPin = ({ id, type, price, active }: IMapPinProps) => {
  const Icon: React.FunctionComponent<{ color?: string }> | undefined = INFRASTRUCTURE_MAP_ICON_MAP.get(type);

  if (type === INFRASTRUCTURE_MAIN) {
    return (
      <div className={styles['pin-main']} data-testid="map-pin-infrastructure">
        {price && (
          <span id={id} className={classNames(styles['pin-main-price'], active && styles['pin-active'])}>
            {price}
          </span>
        )}
      </div>
    );
  }

  if (!Icon) {
    return null;
  }

  return (
    <div className={styles['pin-icon']}>
      <Icon color={'white_100'} />
    </div>
  );
};
